module.exports = __webpack_public_path__ + "static/media/trash.72902955.svg";